/* eslint-disable no-console */
/* eslint-disable prettier/prettier */

/*
 *** toggle the level one menu on horizontal navigation desktop-view
 *** to be a clickable navigation if it has no second level menu
 *** and as a href toggle button if it has second level menu
 */
export default function horizontalNav() {
  const horNavItems = document.querySelectorAll('.horizontal-nav .nav-item');
  horNavItems.forEach((navItem) => {
    // check if it has a level two menu
    let dropdownToggle = navItem.querySelector('.dropdown-toggle-split');
    if (dropdownToggle) {
      // update the href, attibutes and dataset of the level one menu
      let hrefToggle = navItem.querySelector('.nav-link.desktop-view');
      hrefToggle.href = '#';
      hrefToggle.role = 'button';
      hrefToggle.setAttribute('aria-haspopup', true);
      hrefToggle.setAttribute('aria-expanded', false);
      hrefToggle.dataset.toggle = 'dropdown';
    }
  });
}
